import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { INavSidebarService, NavSidebarContentContainer, NavSidebarHeaderItem } from '@mt-ng2/nav-module-config';

import { appNavMenu } from './app-nav-menu.config';

@Injectable()
export class NavSidebarService implements INavSidebarService {
    content: BehaviorSubject<NavSidebarContentContainer[]>;

    navigationMenu: NavSidebarContentContainer;

    constructor() {
        this.navigationMenu = new NavSidebarContentContainer({
            header: new NavSidebarHeaderItem({ content: `NAVIGATION` }),
            rows: appNavMenu,
        });

        this.content = new BehaviorSubject([this.navigationMenu]);
    }
}
